import { handle403Logout } from '../../utils/request';
import { getJobApiCall, postJobApiCall, putJobApiCall } from '../../utils/jobRequest';
import { returnErrors } from './errorAction';
import { GET_CANDIDATE_QUALIFY_QUESTIONS, GET_PREQUALIFYING_DETAILS } from '../Types/types';

// fetch candidate questions
export const fetchCandidateQualifyQuestions = (candidateId , preScreenId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`candidate/${candidateId}/qualify-questions/${preScreenId}`);
    if (response?.status === 200) {
      dispatch({ type: GET_CANDIDATE_QUALIFY_QUESTIONS, payload: response.data.data });
    } else {
      returnErrors(dispatch, response?.data?.message || "Failed to fetch qualifying questions", response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to fetch qualifying questions", error?.response?.status);
  }
};

// submit candidate answer
export const submitCandidateQualifyAnswers = (candidateId, preScreenId, answers) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`candidate/${candidateId}/qualify-answer/${preScreenId}`, answers);
    return response?.status === 200;
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error?.response?.data?.message || "Failed to submit answers", error?.response?.status);
    return false;
  }
};

export const updateHiringAssistaniData = (job_id, id, payload) => async (dispatch) => {
  try {
    const response = await putJobApiCall(`jobs/${job_id}/hiring-stages/${id}`, payload);
    if (response?.status === 200) {
      return response?.data
    } else {
      returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
    }
  } catch (error) {
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    return { success: false, message: "Failed to update assistant" };
  }
}

export const getPreScreenDetails = (id) => async (dispatch) => {
  try {
      const response = await getJobApiCall(`pre-screens/${id}`);
      if (response?.status === 200) {
        dispatch({ type: GET_PREQUALIFYING_DETAILS, payload:response.data.data});
      } else {
        returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status);
      }
    } catch (error) {
      const message = error?.response?.data?.responseMessages?.[0]?.message || error?.response?.data?.message || "Access denied";
      const status = error?.response?.status;
      returnErrors(dispatch, message, status);
      throw error;
  }
}